import { FormattedMessage } from 'react-intl';
import type { InformationFormValues } from '../../../domain/customerInquiry';

interface YourDataDeliveryAddressProps {
  information: InformationFormValues;
}

function YourDataDeliveryAddress({
  information,
}: YourDataDeliveryAddressProps) {
  const { company, street, town, zipcode, country } = information;
  const countryLabel =
    (country as { label?: string; name?: string }).label ?? country.name;

  return (
    <>
      <FormattedMessage id="offerWizard.yourData.deliveryAddress" />
      <br />
      {company}
      <br />
      {street}
      <br />
      {zipcode} {town}
      <br />
      {countryLabel}
    </>
  );
}

export default YourDataDeliveryAddress;
